import type { LoanVM } from "@/models/opal";
import { computed } from "vue";
import { useStore } from "vuex";

export default function useLoanData() {
  const store = useStore();

  /* GETTERS */
  const loan = computed<LoanVM>(() => store.getters["fundsModule/Loan"]);

  /* COMPUTED VALUES */
  const isLoanClosed = computed<boolean>(() => loan.value?.isLoanClosed);
  const loanBoarded = computed<boolean>(() => loan.value?.loanBoarded);
	const fundsDisbursed = computed<boolean>(() => loan.value?.fundsDisbursed === true);

  return { fundsDisbursed, isLoanClosed, loanBoarded, loan };
}
